<template>
    <Card>
        <div class="accordion accordion-solid accordion-panel" id="accordion">
            <div class="card" v-for="(role, index) in roles" :key="index">
               <div class="card-header">
                    <div class="card-title d-flex" :class="[index === roles.length - 1 ? '' : 'collapsed']" data-toggle="collapse" :data-target="`#collapse${index}`">
                        <div class="card-label"><i class="fas fa-user-lock mr-2"></i>{{ __("roles." + `${role.name}`) }}</div>
                        <span class="text-muted">{{ role.power }} <i class="fas fa-bolt"></i></span>
                    </div>
                </div>

                <div :id="`collapse${index}`" class="collapse" :class="[index === roles.length - 1 ? 'show' : '']" data-parent="#accordion">
                    <div class="card-body border-top pt-5">
                        <div class="row">
                            <div class="col-xl-3 col-md-4 col-6" v-for="permission in role.permissions">
                                <dl>
                                    <dt class="font-size-lg">{{ __("permissions." + `${permission.name}`) }}</dt>
                                    <dd class="font-size-sm text-muted">{{ __("permissions.descriptions." + `${permission.name}`) }}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </Card>
</template>

<script>
import {PermissionsMixin} from '@js/permissions';
import Card from '@components/Cards/Card.vue'

export default {
    components: {
        Card,
    },

    mixins: [
        PermissionsMixin,
    ],

    props: {
        roles: Array,
    },

    data() {
        return {
            loading: false,
            filters: {},
            sort: [],
            searchQuery: '',
        };
    },

    methods: {

    },
};
</script>
